import { Fragment } from 'react';

import { LEARNING_SEQUENCE_CATEGORY_EXTRA_CONNECTIONS } from 'global/constants';
import {
  TeachingAndLearningCategoryOptions,
  TeachingAndLearningSequence,
} from './teaching-learning-sequence.constants';
import {
  getRichtextContent,
  isStaticContent,
} from './teaching-learning-sequence.utils';
import TeachingAndLearningOutcomesView from './teaching-and-learning-outcomes-view';
import { TeachingLearningSequenceRichtextView } from './teaching-learning-sequence-richtext';
import { TeachingLearningSequenceRichtextTiptap } from './teaching-learning-sequence-richtext-tiptap';

type Props = {
  categories: TeachingAndLearningCategoryOptions;
  notes?: TeachingAndLearningSequence[];
  isSmall?: boolean;
};

const TeachingLearningSequenceNotesView = ({
  notes,
  categories,
  isSmall,
}: Props) => {
  return (
    <>
      {notes?.map(note => {
        const isExtraConnections =
          note.category === LEARNING_SEQUENCE_CATEGORY_EXTRA_CONNECTIONS &&
          'connections' in note;
        return isExtraConnections ? (
          <TeachingAndLearningOutcomesView
            key={note.id}
            connections={note.connections || []}
          />
        ) : (
          <Fragment key={note.id}>
            {isStaticContent(note.data) ? (
              <TeachingLearningSequenceRichtextView
                content={getRichtextContent(note.data)}
                title={
                  categories.find(cat => cat.value === note.category)?.label ||
                  ''
                }
                isSmall={isSmall}
              />
            ) : (
              <TeachingLearningSequenceRichtextTiptap
                content={getRichtextContent(note.data)}
                title={
                  categories.find(cat => cat.value === note.category)?.label ||
                  ''
                }
                isSmall={isSmall}
              />
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default TeachingLearningSequenceNotesView;
